import {connect} from "react-redux";

import Flags from "../../../components/Dashboard/DashboardUser/Flags";

import * as StudentActions from "../../../store/actions/studentActions";
import * as RemindersActions from "../../../store/actions/remindersActions";
import * as VideoActions from '../../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.reminders,
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        dispatch(VideoActions.getUserCourseContent(courseId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));
        dispatch(RemindersActions.getReminders());
    },
    getLocation: () =>{
        dispatch(StudentActions.getLocationStudent())
    },
    getCurrentSubject: (subjectId, token) => {
        dispatch(VideoActions.getUserSubject(subjectId, token));
    },
    updateCourseUser: (cu, pid, token) => {
        dispatch(VideoActions.updateCourseUser(cu, pid, token));
    },
    loadFlags: (cu, token) => {
        dispatch(VideoActions.getFlags(cu, token));
    },
    loadCourseUserFlags: (courseUserId, token) => {
        dispatch(VideoActions.getCourseUserFlags(courseUserId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Flags);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardUser/FlagContainer.js